// extracted by mini-css-extract-plugin
module.exports = {"status_box":"_1wE5W","status_img":"_1Es6S","status_header":"_3MXgY","status_desc":"_34jTc"};